import _ from "lodash";
import { put, takeLatest } from "redux-saga/effects";
import {
  addOptionAPI,
  createPicklistAPI,
  actionOptionPickListAPI,
  deltePickListAPI,
  editParentPickListAPI,
  editPickListAPI,
  getListPicklistAPI,
  getPicklistAPI,
  getFieldSubAPI,
} from "redux/api/dropListAPI";
import {
  addOption,
  createPickList,
  createPickListSuccess,
  actionOptionPicklist,
  actionOptionPicklistSuccess,
  deletePicklist,
  deletePicklistSuccess,
  editParentPickList,
  editPickList,
  editPickListSuccess,
  getListPicklist,
  getListPicklistSuccess,
  getParentPicklist,
  getParentPicklistSuccess,
  getPicklist,
  getPicklistSuccess,
  getFieldSub,
  getFieldSubSuccess,
} from "redux/slices/dropList";
import { Notification } from "components/Notification/Noti";
import { setShowLoadingScreen } from "redux/slices/global";

export default function* dropListSaga() {
  yield takeLatest(getListPicklist.type, getListPicklistSaga);
  yield takeLatest(getPicklist.type, getPicklistSaga);
  yield takeLatest(getParentPicklist.type, getParentPicklistSaga);
  yield takeLatest(createPickList.type, createPickListSaga);
  yield takeLatest(editPickList.type, editPickListSaga);
  yield takeLatest(editParentPickList.type, editParentPickListSaga);
  yield takeLatest(actionOptionPicklist.type, actionOptionPicklistSaga);
  yield takeLatest(deletePicklist.type, deletePicklistSaga);
  yield takeLatest(addOption.type, addOptionSaga);
  yield takeLatest(getFieldSub.type, getFieldSubSaga);
}

function* getListPicklistSaga(action) {
  try {
    const response = yield getListPicklistAPI(action.payload);
    yield put(getListPicklistSuccess(_.get(response, "data.data")));
  } catch (error) {
    console.log(error);
  }
}

function* getPicklistSaga(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getPicklistAPI(action.payload);
    yield put(getPicklistSuccess(_.get(response, "data.data")));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    console.log(error);
    yield put(setShowLoadingScreen(false));
  }
}

function* getParentPicklistSaga(action) {
  try {
    const response = yield getPicklistAPI(action.payload);

    const fieldsMapping = _.get(_.get(response, "data.data"), "field_mapping");
    const dataOptions = _.get(_.get(response, "data.data"), "data_select").map(
      (item) => {
        return {
          key: _.get(item, `${fieldsMapping.key}.value`),
          value: _.get(item, `${fieldsMapping.value}.value`),
          disabled: _.get(item, `${fieldsMapping.disabled}.value`),
          _id: _.get(item, "_id"),
        };
      }
    );

    yield put(getParentPicklistSuccess(dataOptions));
  } catch (error) {
    console.log(error);
  }
}

function* createPickListSaga(action) {
  try {
    const res = yield createPicklistAPI(action.payload);
    yield put(createPickListSuccess(res.data.data));
    yield put(getListPicklist());
    Notification("success", "Create successfully!");
  } catch (error) {
    console.log(error);
    // yield put(createPickListSuccess());
    Notification("error", error.response.data.error);
  }
}

function* editPickListSaga(action) {
  try {
    yield editPickListAPI(action.payload);
    yield put(editPickListSuccess(_.get(action, "payload.name")));
    yield put(getListPicklist());
    Notification("success", "Update successfully!");
  } catch (error) {
    console.log(error);
    // yield put(editPickListSuccess());
    Notification("error", error.response.data.error);
  }
}

function* editParentPickListSaga(action) {
  try {
    yield editParentPickListAPI(action.payload);
    yield put(
      getParentPicklist({
        picklist_id: _.get(action.payload, "parent_id"),
      })
    );
    yield put(
      getPicklist({
        picklist_id: _.get(action.payload, "picklist_id"),
      })
    );

    // yield put(editPickListSuccess());
    // yield put(getListPicklist());
    Notification("success", "Update successfully!");
  } catch (error) {
    console.log(error);
    // yield put(editPickListSuccess());
    Notification("error", error.response.data.error);
  }
}

function* actionOptionPicklistSaga(action) {
  try {
    yield actionOptionPickListAPI(action.payload.data);
    yield put(actionOptionPicklistSuccess());
    yield put(
      getPicklist({
        picklist_id: action.payload.picklist_id,
      })
    );
    Notification("success", "Successfully!");
  } catch (error) {
    console.log(error);
    Notification("error", error.response.data.error);
    yield put(actionOptionPicklistSuccess());
  }
}

function* deletePicklistSaga(action) {
  try {
    yield deltePickListAPI(action.payload);
    yield put(deletePicklistSuccess());
    yield put(getListPicklist());
    Notification("success", "Delete successfully!");
  } catch (error) {
    yield put(deletePicklistSuccess());
    Notification("error", error.response.data.error);
  }
}

function* addOptionSaga(action) {
  try {
    yield addOptionAPI(action.payload);
    Notification("success", "Add successfully!");
  } catch (error) {
    // yield put(deletePicklistSuccess());
    Notification("error", error.response.data.error);
  }
}

function* getFieldSubSaga(action) {
  try {
    const res = yield getFieldSubAPI(action.payload);
    yield put(getFieldSubSuccess(_.get(res, "data.data")));
  } catch (error) {}
}
